import { Helmet } from "react-helmet-async";
import { useEffect, useState, useCallback } from "react";
// @mui
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
  Grid,
  FormControl,
  TextField,
  Button
} from "@mui/material";

import axios from "axios";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
// ----------------------------------------------------------------------

export default function EditBracketSettingPage() {
  const [searchParams] = useSearchParams();
  const [competition, setCompetition] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [bracketId, setBracketId] = useState(false);
  const [allowMultiple, setAllowMultiple] = useState(false);
  const [openSectionsUtc, setOpenSectionsUtc] = useState();
  const [closeSectionsUtc, setCloseSectionsUtc] = useState();
  const [tiebreakerAnswer, setTiebreakerAnswer] = useState();

  useEffect(() => {
    if (searchParams.has("type")) {
      const competition = searchParams.get("type");
      setCompetition(competition);
    }
  }, [searchParams]);

  const getData = (competition) => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/admin/bracket-setting?competition=${competition}`)
      .then(function (response) {
        const data = response?.data;
        setLoading(false);
        setBracketId(data.bracketId)
        setAllowMultiple(data?.allowMultipleBracket || false);
        setOpenSectionsUtc(data?.openSelectionsUtc);
        setCloseSectionsUtc(data?.closeSelectionsUtc);
        setTiebreakerAnswer(data.tiebreakerAnswer)
      });
  };

  const fn = useCallback(() => getData(competition), [competition])
  useEffect(() => {
    if(competition) fn(competition)
  }, [competition, fn])

  useEffect(() => {
    if(!!openSectionsUtc && !!closeSectionsUtc) {
      const diffDays = moment(openSectionsUtc).diff(closeSectionsUtc, 'days');
      if(!!diffDays && diffDays >= 0) setError(true);
      else setError(false);
    }
  }, [openSectionsUtc, closeSectionsUtc])

  const handleSubmit = () => {
  console.log("submit clicked", {
    bracketId,
    openSectionsUtc,
    closeSectionsUtc,
    tiebreakerAnswer,
    competition,
  });

  if (!bracketId) {
    console.log("No bracketId");
    return;
  }

  if (!openSectionsUtc) {
    console.log("No openSectionsUtc");
    return;
  }

  if (!closeSectionsUtc) {
    console.log("No closeSectionsUtc");
    return;
  }

  setLoading(true);

  axios
    .put(`${process.env.REACT_APP_API_BASE_URL}/admin/bracket-setting`, {
      bracketId,
      allowMultipleBracket: allowMultiple,
      openSelectionsUtc: openSectionsUtc,
      closeSelectionsUtc: closeSectionsUtc,
      tiebreakerAnswer,
      competition,
    })
    .then((res) => {
      console.log("PUT success", res.data);
      setDisabled(true);
    })
    .catch((err) => {
      console.error("PUT failed", err?.response?.data || err);
    })
    .finally(() => setLoading(false));
};

  return (
    <>
      <Helmet>
        <title> Bracket Setting </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Bracket Setting
          </Typography>
        </Stack>

        <Card style={{ padding: 20 }}>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>

                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="Open Selections Utc"
                      value={openSectionsUtc}
                      onChange={(newValue) => setOpenSectionsUtc(newValue)}
                      renderInput={(params) => (
                        <TextField 
                          {...params} 
                          error={error} 
                          helperText="The open date cannot be later than the close date" 
                        />
                      )}
                      disabled={disabled}
                    />
                  </LocalizationProvider>
                </FormControl>
                
                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="Close Selections Utc"
                      value={closeSectionsUtc}
                      onChange={(newValue) => setCloseSectionsUtc(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                      disabled={disabled}
                    />
                  </LocalizationProvider>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                    <TextField
                      required
                      label="Right Answer on Tiebreaker"
                      placeholder="Right Answer on Tiebreaker"
                      name={'right_answer'}
                      value={tiebreakerAnswer || ""}
                      onChange={(e) => setTiebreakerAnswer(e.target.value)}
                      variant="outlined"
                      disabled={disabled}
                    />
                  </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12} >
                {
                  disabled && (
                    <Button
                      variant="contained"
                      onClick={() => setDisabled(false)}
                    >
                      Edit
                    </Button>
                  )
                }
                {
                  !disabled && (
                    <>
                      <Button
                        variant="contained"
                        onClick={() => handleSubmit()}
                        disabled={!!error}
                      >
                        Update
                      </Button>
                      <Button onClick={() => setDisabled(true)}>Cancel</Button>
                    </>
                  )
                }
              </Grid>
            </Grid>
          )}
        </Card>
      </Container>
    </>
  );
}
